import { render } from "./RequestSubject.vue?vue&type=template&id=79823de1&scoped=true"
import script from "./RequestSubject.vue?vue&type=script&lang=js"
export * from "./RequestSubject.vue?vue&type=script&lang=js"

import "./RequestSubject.vue?vue&type=style&index=0&id=79823de1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79823de1"]])

export default __exports__